<script>
  import { createEventDispatcher } from 'svelte';

  export let text = '';
  export let variant = 'secondary';
  export let icon = '';
  export let iconLeft = false;
  const dispatch = createEventDispatcher();
  
  let open = false;

  function toggleDropdown() {
    open = !open;
  }

  function closeDropdown() {
    open = false;
  }

  function handleClick(item) {
    dispatch('select', item);
    closeDropdown();
  }
</script>

<style>
  .dropdown {
    position: relative;
    display: inline-block;
    z-index: 10000; /* Increase the z-index */
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: white;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
    z-index: 10001; /* Ensure the content is on top */
    border-radius: var(--br);
  }

  .dropdown-content.open {
    display: block;
  }

  .dropdown-item {
    padding: 8px 16px;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: #ddd;
  }

  .button {
    border-radius: 0.5rem;
    color: var(--pax-white);
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    white-space: nowrap;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    height: 3rem;
    transition: 100ms ease-in-out;
    background-color: var(--pax-black);
  }
  .button:hover {
    background-color: var(--pax-orange);
  }
</style>

<div class="dropdown">
  <button on:click={toggleDropdown} class="button {variant}">
    {#if iconLeft}
      <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
    {/if}
    {text}
    {#if !iconLeft}
      <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
    {/if}
  </button>
  <div class="dropdown-content {open ? 'open' : ''}" on:mouseleave={closeDropdown}>
    <slot />
  </div>
</div>
